var _ = require("lodash");
var esUtils = require("./esUtils");

module.exports = {
	getInitialState: function(){
		this.__HoverMixin_fast_state = {
			hover: false,
			last_time: _.now(),
			interval: 100,
			timeout_handle: null,
			on_user_left_waitfor: 500,
			on_user_left_debounce_handler: null
		};
		return {hover: false, hoverable_top: 0, hoverable_left: 0};
	},
	___fastStateChangeHover: function(){
		var diff = _.now() - this.__HoverMixin_fast_state.last_time;
		if(diff >= this.__HoverMixin_fast_state.interval){
			var self = this;

			this.setState({hover: this.__HoverMixin_fast_state.hover}, function(){
				if(_.isFunction(self.hoverable_onUserLeftHoverable) && !self.__HoverMixin_fast_state.hover){
					clearTimeout(self.__HoverMixin_fast_state.on_user_left_debounce_handler);
					self.__HoverMixin_fast_state.on_user_left_debounce_handler = setTimeout(function(){
						if(!self.state.hover){//only if still not hovering after the time has passed
							self.hoverable_onUserLeftHoverable();
						}
					}, self.__HoverMixin_fast_state.on_user_left_waitfor);
				}
			});
			this.__HoverMixin_fast_state.last_time = _.now();
		}else{
			clearTimeout(this.__HoverMixin_fast_state.timeout_handle);
			this.__HoverMixin_fast_state.timeout_handle = setTimeout(this.___fastStateChangeHover, diff);
		}
	},
	hoverable_onMouseEnter: function(){
		this.__HoverMixin_fast_state.hover = true;
		this.___fastStateChangeHover();
	},
	hoverable_onMouseLeave: function(){
		this.__HoverMixin_fast_state.hover = false;
		this.___fastStateChangeHover();
	},
	componentDidUpdate: function(){
		var dom_node = this.refs.hoverable;
		if(!dom_node || !this.state.hover){
			return;
		}
		var parentNode = dom_node.parentNode;
		var rect = parentNode.getBoundingClientRect();
		var parent_width = Math.max(0, parentNode.offsetWidth);
		if(this.not_relative_to_parent_bounding_rect){
			rect = {top: 0, left: 0};
		}
		var top = esUtils.toInt(rect.top - Math.max(0, dom_node.offsetHeight));
		var left = esUtils.toInt(rect.left - (dom_node.offsetWidth / 2) + (parent_width / 2));

		var new_state = {};
		if(Math.abs(top - this.state.hoverable_top) > 5){//only make changes when needed so we don't get into a loop (some loops are over a few pixels difference)
			new_state.hoverable_top = top;
		}
		if(Math.abs(left - this.state.hoverable_left) > 5){//only make changes when needed so we don't get into a loop (some loops are over a few pixels difference)
			new_state.hoverable_left = left;
		}
		if(!_.isEmpty(new_state)){
			this.setState(new_state);
		}
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/utils/HoverMixin.js
// module id = 49
// module chunks = 0 1 2 3 4